export enum ViewType {
  GRID = 'grid',
  LIST = 'list',
  CALENDAR = 'calendar',
  KANBAN = 'kanban',
  FORM = 'form',
  TIMELINE = 'timeline'
}
